<div class="toolbar">
    <div class="portal-content">
        <ng-template [cdkPortalOutlet]="portal()" />
    </div>

    <div class="menu-button" [matMenuTriggerFor]="userMenu">
        <div class="btn-content">
            <span class="username">{{ username() }}</span>
            <span class="org-name">{{ orgName() }}</span>
        </div>

        <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>

        <button class="mobile-button" mat-icon-button>
            <mat-icon fontSet="material-icons-outlined">account_circle</mat-icon>
        </button>

    </div>

    <mat-menu #userMenu="matMenu">
        <div class="menu-top">
            <div class="btn-content">
                <span class="username">{{ username() }}</span>
                <span class="org-name">{{ orgName() }}</span>
            </div>

            <mat-divider></mat-divider>
        </div>

        <button i18n='@@app.navbar.logout' mat-menu-item (click)="logout.emit()">
            <mat-icon>logout</mat-icon>
            Logout
        </button>
    </mat-menu>
</div>
